import { XAxisProps } from '../components/axis/types/annotations-x-axis-props.js';

export const XAxis = (props: XAxisProps) => null;

XAxis['displayName'] = 'Annotations.XAxis';
